"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var size = {
    tiny: theme_1.default.dimensions.avatar.tiny,
    compact: theme_1.default.dimensions.avatar.compact,
    small: theme_1.default.dimensions.avatar.small,
    medium: theme_1.default.dimensions.avatar.medium,
    large: theme_1.default.dimensions.avatar.large,
};
var borderSize = 4;
var activeBorderStyle = "".concat(borderSize, "px solid ").concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.2));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            boxSizing: 'content-box',
            height: size.small,
            minWidth: size.small,
            width: size.small,
            backgroundSize: size.small + borderSize,
            borderRadius: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            fontSize: '12px',
            overflow: 'hidden',
        },
        large: {
            height: size.large,
            minWidth: size.large,
            width: size.large,
            backgroundSize: size.large + borderSize,
            fontSize: '18px',
        },
        medium: {
            height: size.medium,
            minWidth: size.medium,
            width: size.medium,
            backgroundSize: size.medium + borderSize,
            fontSize: '16px',
        },
        compact: {
            height: size.compact,
            minWidth: size.compact,
            width: size.compact,
            backgroundSize: size.compact + borderSize,
            fontSize: '10px',
        },
        tiny: {
            height: size.tiny,
            minWidth: size.tiny,
            width: size.tiny,
            backgroundSize: size.tiny + borderSize,
            fontSize: '8px',
        },
        interactive: {
            margin: "-".concat(borderSize, "px"),
            border: "".concat(borderSize, "px solid transparent"),
            backgroundClip: 'content-box',
            cursor: 'pointer',
            '&:hover': {
                border: activeBorderStyle,
            },
        },
        toggled: {
            border: activeBorderStyle,
        },
        initials: {
            color: 'white',
            fontFamily: theme_1.default.fontFamily,
            fontWeight: 'bold',
            letterSpacing: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%',
            backgroundColor: theme_1.default.colors.primaryDark,
        },
        photo: {
            height: 0,
            width: 0,
        },
    });
});
